/**
 * GoodFarmer Frontend Configuration
 * 환경별 설정값들을 중앙화하여 관리
 */

// 환경 감지
export const isProduction = window.location.hostname !== 'localhost';

// 백엔드 설정
export const BACKEND_CONFIG = {
  // 프로덕션 환경에서는 Fly.io 백엔드 사용
  PRODUCTION_HOST: 'goodfarmer-backend.fly.dev',
  // 개발 환경에서는 현재 호스트 사용 (프록시 통해서)
  DEVELOPMENT_HOST: window.location.host,
  // 현재 환경에 따른 백엔드 호스트
  HOST: isProduction ? 'goodfarmer-backend.fly.dev' : window.location.host,
  // 프로토콜 설정: 프로덕션은 항상 HTTPS, 개발은 현재 프로토콜 사용
  PROTOCOL: isProduction ? 'https' : (window.location.protocol === 'https:' ? 'https' : 'http'),
  WS_PROTOCOL: isProduction ? 'wss' : (window.location.protocol === 'https:' ? 'wss' : 'ws'),
} as const;

// API 설정
export const API_CONFIG = {
  // 개발환경: 현재 호스트 + 상대경로, 프로덕션: 직접 백엔드 URL
  BASE_URL: isProduction
    ? `${BACKEND_CONFIG.PROTOCOL}://${BACKEND_CONFIG.HOST}/api/v1`
    : '/api/v1',
  TIMEOUT: 10000, // 10초
} as const;

// WebSocket 설정
export const WEBSOCKET_CONFIG = {
  URL: isProduction
    ? `${BACKEND_CONFIG.WS_PROTOCOL}://${BACKEND_CONFIG.HOST}/ws`
    : `${BACKEND_CONFIG.WS_PROTOCOL}://${window.location.host}/ws`,
  RECONNECT_INTERVAL: 3000, // 3초
  MAX_RECONNECT_ATTEMPTS: -1, // 무한 재연결
  PING_INTERVAL: 30000, // 30초
} as const;

// 앱 설정
export const APP_CONFIG = {
  NAME: 'GoodFarmer',
  VERSION: '1.0.0',
  DESCRIPTION: 'Smart Agriculture Management System',
} as const;

// 로깅 설정
export const LOG_CONFIG = {
  LEVEL: isProduction ? 'info' : 'debug',
  ENABLE_CONSOLE: true,
  ENABLE_REMOTE: false,
} as const;

// 개발 도구 설정
export const DEV_CONFIG = {
  ENABLE_DEBUG: !isProduction,
  ENABLE_HOT_RELOAD: !isProduction,
  ENABLE_DEVTOOLS: !isProduction,
} as const;

// 환경 정보 출력 (개발 환경에서만)
if (!isProduction) {
  console.log('🔧 Development Configuration:', {
    backend: BACKEND_CONFIG.HOST,
    api: API_CONFIG.BASE_URL,
    websocket: WEBSOCKET_CONFIG.URL,
    protocol: BACKEND_CONFIG.PROTOCOL,
  });
}
